import { audioManager, type SfxCue } from "./AudioManager";

export function playAudioCue(cue: SfxCue) {
  audioManager.playSfx(cue);
}

export function setAudioScrollIntensity(scrollVelocity: number) {
  audioManager.setScrollIntensity(scrollVelocity);
}

